import React from 'react';

const CustomerDemographics = ({ demographics }) => {
    const { totalCustomers, genderBreakdown, ageGroups } = demographics;

    return (
        <div
            style={{
                backgroundColor: '#fff',
                padding: '24px',
                borderRadius: '12px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                marginBlock: "10px"
            }}
        >
            {/* Section Title */}
            <h2 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#111',
            }}>
                Customer Demographics
            </h2>

            {/* Total Customers */}
            <div style={{
                backgroundColor: '#f9f9f9',
                padding: '16px',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '500',
                color: '#333',
            }}>
                Total Customers: <strong>{totalCustomers}</strong>
            </div>

            {/* Gender & Age Breakdown side-by-side */}
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px',
                }}
            >
                {/* Gender Breakdown */}
                <div style={{
                    backgroundColor: '#f9f9f9',
                    padding: '16px',
                    borderRadius: '8px',
                    flex: '1 1 300px',
                    minWidth: '280px',
                }}>
                    <h3 style={{
                        fontSize: '1rem',
                        fontWeight: '600',
                        color: '#333',
                        marginBottom: '12px'
                    }}>
                        Gender Breakdown
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {genderBreakdown.map((item) => (
                            <div
                                key={item.gender}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: '0.95rem',
                                    color: '#555',
                                    textTransform: "capitalize"
                                }}
                            >
                                <span>{item.gender}</span>
                                <span>{item.count} ({item.percentage}%)</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Age Group Breakdown */}
                <div style={{
                    backgroundColor: '#f9f9f9',
                    padding: '16px',
                    borderRadius: '8px',
                    flex: '1 1 300px',
                    minWidth: '280px',
                }}>
                    <h3 style={{
                        fontSize: '1rem',
                        fontWeight: '600',
                        color: '#333',
                        marginBottom: '12px'
                    }}>
                        Age Group Breakdown
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {ageGroups.map((item) => (
                            <div
                                key={item.label}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: '0.95rem',
                                    color: '#555',
                                    textTransform: "capitalize"
                                }}
                            >
                                <span>{item.label}</span>
                                <span>{item.count} ({item.percentage}%)</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerDemographics;
